module.exports = __webpack_public_path__ + "img/defaultCoinIco.f19aaad3.png";